<template>
  <div class="department">
    <Input
      v-if="list.length"
      :value="searchKeyWord"
      @on-search="onSearch"
      search
      placeholder="部门名称搜索"
    ></Input>
    <!--<template v-show="list.length">-->
      <MyTree
        :data="list"
        @on-change="onTreeChange"
        :multiple="multiple"
        ref="tree"
        :empty-text="emptyText"
        :filter-node-method="filterNode"
        :props="defaultProps"
      />
    <!--</template>-->
    <!--<template v-show="!list.length">-->
      <!--<p style="text-align: center;padding-top: 40px;">无数据</p>-->
    <!--</template>-->
  </div>
</template>

<script>
import mixin from "../mixin";
import { getDepartment } from "@/api/components";
import MyTree from "@/components/my-tree";
export default {
  name: "depart",
  mixins: [mixin],
  props: {
    checkedIds: {
      type: Array
    }
  },
  created() {
    this.getAjaxData();
  },
  mounted() {
    this.checkedData = this.checked;
  },
  data() {
    return {
      list: [],
      checkedData: [],
      searchKeyWord: "",
      defaultProps: {
        children: "children",
        label: "title"
      }
    };
  },
  computed: {
    emptyText() {
      return `未找到${this.searchKeyWord}相关内容`;
    }
  },
  methods: {
    onSearch(value) {
      this.searchKeyWord = value;
      this.$refs.tree.filter(value);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.title.indexOf(value) !== -1;
    },
    setChecked() {
      this.$nextTick(() => {
        this.$refs.tree.setCheckedNodes(this.checkedData);
      });
    },
    getAjaxData() {
      getDepartment()
        .then(res => {
          this.list = this.formatAjaxData(res.data);
          this.setChecked();
        })
        .catch(err => {
          const { status } = err;
          if (status === "002") {
            this.list = [];
          }
        });
    },
    formatAjaxData(ajaxData) {
      function jsonTree(data) {
        let result = [];
        data.forEach(item => {
          result.push({
            id: item.id,
            title: item.department,
            children: jsonTree(item.lists || [])
          });
        });
        return result;
      }
      return jsonTree(ajaxData);
    },
    onTreeChange(checkNodes) {
      this.checkedData = checkNodes;
      this.$emit("on-change", this.checkedData);
    },
    del(node) {
      let { id } = node;
      this.checkedData.forEach((item, index) => {
        if (item.id === id) {
          this.checkedData.splice(index, 1);
        }
      });
      this.$refs.tree.setCheckedNodes(this.checkedData);
    }
  },
  components: {
    MyTree
  },
  watch: {
    checkedIds(val) {
      val.forEach(id => {
        this.checkedData.push({ id });
      });
    }
  }
};
</script>

<style scoped lang="less">
.choose-staff {
  &-item {
    border-bottom: 1px solid #e1e3e5;
    padding: 9px 0;
    &-title {
      font-size: 14px;
      color: #333;
    }
    &-name {
      font-size: 12px;
      color: #666;
    }
  }
}
</style>
